<template>
	<!-- 咨询弹窗开始 -->
	<el-dialog :title="title" :visible.sync="mdVisible" append-to-body :destroy-on-close="true" @close="handleCancel"
		:closeOnClickModal="false" width="20%" top="0vh" custom-class="center-dialog" :lock-scroll="false">
		<div class="popMainOther">
			<!-- <h1>400-800-1519</h1> -->
			<div class="popMainOtherItem">
				<div><img src="../../../assets/img/consultPhone4.png" alt=""></div>
				<div>
					<p>咨询热线：</p>
				</div>
				<div>
					<p>13774390445</p>
				</div>
			</div>
			<div class="popMainOtherItem">
				<div><img src="../../../assets/img/consultYou2.png" alt=""></div>
				<div>
					<p>邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;箱：</p>
				</div>
				<div>
					<p>2397018259@qq.com</p>
				</div>
			</div>
			<div class="popMainOtherItem">
				<div><img src="../../../assets/img/consultAddress2.png" alt=""></div>
				<div>
					<p>地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：</p>
				</div>
				<div>
					<p>上海市徐家汇宜山路515号环线广场1号楼19G</p>
				</div>
			</div>
		</div>
	</el-dialog>
	<!-- 咨询弹窗结束 -->
</template>

<script>
	export default {
		data() {
			return {
				mdVisible: false,
				title: ""
			};
		},
		methods: {
			show() {
				this.mdVisible = true
			},
			close() {
				this.mdVisible = false
			},
			handleCancel() {
				this.close()
			}
		},
	}
</script>

<style lang="scss">
	// 控制的dialog样式需要穿透到底层，所以这里不能写scoped属性
	// 如果不想影响全局，可以给el-dialog的父级定义一个class,再把.center-dialog置于这个class的嵌套里面
	.center-dialog {
		top: 50%;
		transform: translateY(-50%);
		border-radius: 10px;
	}

	.popMainOther {
		height: auto;
		overflow-y: auto;
		padding: 10px 20px;
		text-align: center;

		.popMainOtherItem {
			width: 100%;
			display: flex;
			flex-direction: row;
			margin-bottom: 15px;

			img {
				width: 25px;
				height: 25px;
			}

			p {
				text-align: left;
				line-height: 25px;
				font-size: 14px;
			}
		}
	}

	.popMainOtherItem:nth-child(1)>div:nth-child(1) {
		position: relative;
		top: 2px;
		animation: jump .5s ease-in-out infinite alternate;
	}

	.popMainOtherItem>div:nth-child(2) {
		margin: 0 2px 0 15px;
	}

	.popMainOtherItem:last-child {
		margin-bottom: 0;
	}

	@keyframes jump {
		from {
			top: -2px;
		}

		to {
			top: 2px
		}
	}



	/*滚动条样式*/
	.popMainOther::-webkit-scrollbar {
		width: 4.5px; //纵向滚动条的宽度
	}

	.popMainOther::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.15);
		background: rgba(0, 0, 0, 0.08);
	}

	// .popMain::-webkit-scrollbar-track {
	// 	-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.15);
	// 	border-radius: 0;
	// 	background: rgba(0, 0, 0, 0.08);
	// }

	/*滚动条样式*/



	// 修改弹窗样式
	.center-dialog .el-dialog__header {
		padding: 0px;
	}

	.center-dialog .el-dialog__headerbtn {
		top: 18px;
		right: 18px;
	}

	.center-dialog .el-dialog__body {
		padding: 30px 10px;
		padding-top: 40px;
	}

	.center-dialog .el-dialog__headerbtn .el-dialog__close {
		font-weight: 600;
	}
</style>
<style>
	/deep/ .el-dialog__wrapper {
		overflow: hidden;
	}

	/deep/ .el-popup-parent--hidden {
		padding-right: 0 !important;
	}

	/* /deep/ .el-dialog {
		background: rgba(238, 241, 249, 0.96);
	} */
</style>